import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper as SwiperClass } from "swiper/types";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { SwipeIndicator } from "@danishagro/shared/src/components/atoms/SwipeIndicator/SwipeIndicator.component";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import {
    SSH_ArrowButton,
    SSH_arrowDirection,
} from "../../molecules/ArrowButton/ArrowButton.component";
import { SSH_HeroListProps } from "../HeroList/HeroList.component";
import S from "./HeroSlider.module.scss";

export const SSH_HeroSlider = ({ blocks, BlockRenderer }: SSH_HeroListProps) => {
    const [thumbsSwiper, setThumbsSwiper] = useState<SwiperClass>(null);
    const thumbsSwiperRef = useRef(null);
    const paginationRef = useRef<HTMLSpanElement>(null);
    const [activeIndex, setActiveIndex] = useState(0);

    const isFirst = activeIndex === 0;
    const isLast = activeIndex === blocks.length - 1;

    return (
        <section>
            <div className={S.sliderContainer}>
                <Swiper
                    modules={[Navigation, Pagination]}
                    onSwiper={(swiper) => {
                        setThumbsSwiper(swiper);
                        thumbsSwiperRef.current = swiper;
                    }}
                    pagination={{
                        clickable: true,
                        el: paginationRef.current,
                    }}
                    navigation
                    onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                >
                    {blocks.map((block, index) => {
                        const mappedProps = {
                            ...block.props,
                            className: "heroListItem",
                            headlineTag: index === 0 ? "h1" : "h2",
                            columns: blocks?.length,
                        };

                        return (
                            <SwiperSlide key={block.key}>
                                <BlockRenderer block={{ ...block, props: mappedProps }} />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                {/* Prev and next arrow buttons */}
                {blocks.length > 1 && (
                    <div>
                        {!isFirst && (
                            <SSH_ArrowButton
                                onCLick={() => thumbsSwiper.slidePrev()}
                                className={cn(S.button, S.buttonPrev)}
                                iconDirection={SSH_arrowDirection.Left}
                                small
                            />
                        )}
                        {!isLast && (
                            <SSH_ArrowButton
                                onCLick={() => thumbsSwiper.slideNext()}
                                className={cn(S.button, S.buttonNext)}
                                iconDirection={SSH_arrowDirection.Right}
                                small
                            />
                        )}
                    </div>
                )}
            </div>

            {/* Pagination for image slider */}
            {blocks.length > 1 && (
                <div className={S.paginationWrapper}>
                    <span
                        ref={paginationRef}
                        className={cn(S.slidePagination, "swiperPagination")}
                    />

                    {/* Swipe indicator animation */}
                    <SwipeIndicator className={S.swipeIcon} />
                </div>
            )}
        </section>
    );
};
